import { render, staticRenderFns } from "./ProdExtSkuLogs.vue?vue&type=template&id=68b56d3e&scoped=true&"
import script from "./ProdExtSkuLogs.vue?vue&type=script&lang=js&"
export * from "./ProdExtSkuLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b56d3e",
  null
  
)

export default component.exports